export function buildClassChangeMailtoLink(userName = '') {
  return `mailto:contact@jeddle.com?subject=Class%20Changes&body=To%20make%20any%20class%20changes,%20please%20include%20the%20following%20details%20below:%0A%0ASchool%20name:%0A%0AYour%20full%20name:%20${userName}%0A%0AList%20of%20requested%20changes%20(inc.%20full%20student%20names%20AND%20class%20codes%20of%20old%20and%20new%20classes):`;
}

export function openClassChangeRequest(userName = '') {
  window.open(buildClassChangeMailtoLink(userName), '_blank');
}
